import { useEffect } from 'react'
import { getToken, onMessage } from 'firebase/messaging'
import { messaging } from '../lib/firebase'
import { supabase } from '../lib/supabase'
import useAuthStore from '../store/authStore'
import { isMobile, isStandalone, onInstalled } from '../lib/pwa'

const VAPID_KEY = 'BC7niLALfhtoZI31xOQzjhsBCH05DgOKXiW8V_xoymZXt70YQQNL0SOvOHria-jmiC3bdZ4ZLlDdxQ4Cr0WC4is'

// Fetches the FCM token and upserts it to push_tokens.
// Call AFTER Notification.permission === 'granted' AND the app is installed (standalone).
export async function registerPushToken(userId) {
  if (!userId) return null
  if (typeof Notification === 'undefined') return null
  if (Notification.permission !== 'granted') return null
  if (!isStandalone()) return null

  const swRegistration = await navigator.serviceWorker.ready
  const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swRegistration })
  if (!token) return null

  await supabase.from('push_tokens').upsert(
    { user_id: userId, token, updated_at: new Date().toISOString() },
    { onConflict: 'user_id' }
  )
  return token
}

export function usePushNotifications() {
  const userId = useAuthStore(s => s.user?.id)

  useEffect(() => {
    if (!userId) return
    if (!isMobile()) return
    if (typeof Notification === 'undefined') return
    if (Notification.permission === 'denied') return

    const setup = async () => {
      if (!isStandalone()) return
      try {
        if (Notification.permission === 'default') {
          const permission = await Notification.requestPermission()
          if (permission !== 'granted') return
        }
        await registerPushToken(userId)
      } catch (err) {
        console.warn('[Push] setup failed:', err)
      }
    }

    setup()
    const offInstalled = onInstalled(() => setup())

    // Foreground notifications (app open)
    const unsubscribe = onMessage(messaging, async (payload) => {
      console.log('[Push] foreground message:', payload)
      const title = payload.data?.title || payload.notification?.title || 'Mindesk'
      const body  = payload.data?.body  || payload.notification?.body  || ''
      const reg = await navigator.serviceWorker.ready
      reg.showNotification(title, { body, icon: '/icon-192.png', badge: '/icon-192.png' })
    })

    return () => {
      offInstalled()
      unsubscribe()
    }
  }, [userId])
}
